import type { $Fetch } from 'ofetch';
import type { OnboardTenantCommand, OnboardTenantResult } from '@/domain/model/TenantOnboarding';
import type { TenantOnboardingGateway } from '@/application/port/out/TenantOnboardingGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/admin/onboarding/tenant';

/** HTTP gateway do onboarding de IES. Authority BE: `org:tenant:create` (SUPERADMIN). */
export class HttpTenantOnboardingGateway implements TenantOnboardingGateway {
  constructor(private readonly client: $Fetch) {}

  async onboard(cmd: OnboardTenantCommand): Promise<OnboardTenantResult> {
    const res = await this.client<ApiResponse<OnboardTenantResult>>(PATH, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
